import { StaticPropsContext } from '@otovo/shared/lib/next/types';
import {
  Sanity$CampaignPage,
  Sanity$DocumentType,
} from '@otovo/shared/types/sanityTypes';
import { useQuery } from '@sanity/react-loader';
import { InferGetStaticPropsType } from 'next';
import GenericLandingPage from '../../components/SanityLandingPage/GenericLandingPage';
import { landingPageQuery } from '../../components/SanityLandingPage/sanityQueries';
import {
  getStaticProps as getStaticMarketProps,
  getStaticPathsForSanityPages,
} from '../../config/getProps';
import { fetchSanityDocumentWrapper } from '../../lib/sanity/fetchSanityDocumentWrapper';

type PageProps = InferGetStaticPropsType<typeof getStaticProps>;

const LandingPage = ({ config, initial, query }: PageProps) => {
  const { data } = useQuery(query, {}, { initial });
  return <GenericLandingPage config={config} sanityDocument={data} />;
};

const LANDING_PAGE_TYPE: Sanity$DocumentType = 'landingPage';

export async function getStaticPaths() {
  return getStaticPathsForSanityPages({
    pageType: LANDING_PAGE_TYPE,
  });
}

export async function getStaticProps(context: StaticPropsContext) {
  return fetchSanityDocumentWrapper<Sanity$CampaignPage>({
    context,
    sanityQuery: ({ BU_CONFIG }) =>
      landingPageQuery(
        LANDING_PAGE_TYPE,
        context.params.slug,
        BU_CONFIG,
        context.locale,
      ),
    getStaticMarketProps,
    draftMode: context.draftMode,
  });
}

export default LandingPage;
